module.exports = __webpack_public_path__ + "static/media/quote_grey.a078bd6b.svg";